module.exports = __webpack_public_path__ + "r-v3/img/translation_ZH-CN.03b100aa.png";